import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialState = {
  expirationDate: null,
};

export const useEbooksStore = create(
  persist(
    (set, get) => ({
      ...initialState,
      
      setEbooksExpirationDate: (expirationDate) => set({ expirationDate }),
      
      clearEbooksData: () => set({ expirationDate: null }),
      
      isTokenExpired: () => {
        const { expirationDate } = get();
        if (!expirationDate) return true;
        const expiration = new Date(expirationDate);
        const now = new Date();
        return expiration < now;
      },
    }),
    {
      name: 'ebooks-storage',
      partialize: (state) => ({
        expirationDate: state.expirationDate
      })
    }
  )
);

